/* eslint-disable no-console */
<template>
  <div>
    <loading v-model="isLoading"
                 :active="isLoading"
                 :can-cancel="false"
                 :on-cancel="onCancel"
                 :is-full-page="true"/>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">Edit Progress</h4>
      <div class="d-flex justify-content-between align-items-start flex-wrap">
        <div>
          <h4 class="text text-capitalize mb-2">
            {{student.first_name}} {{student.last_name}}
          </h4>
          <p>This student is at <b>{{student.age_bracket}}</b>
          <b v-if="progress.level_data">, {{progress.level_data.title}}, 
          Lesson {{progress.group}}, Day {{progress.day}},</b>
          <b v-if="progress.type=='s'"> Static</b>
          <b v-if="progress.type=='a'"> Audible</b>
          <b v-if="progress.type=='f'"> Flash</b></p>
        </div>
        <div class="reset-smartbook-wrapper text-right mt-2 mt-md-0">
          <button
            class="btn reset-smartbook-btn"
            title="Reset Smartbook"
            aria-label="Reset Smartbook"
            @click.prevent="openResetModal()"
          >
            <span class="material-icons">refresh</span>
          </button>
        </div>
      </div>
      <div>
        <!-- Default form login -->
        <form class="border border-light p-5">
          <div class="row">
            <div class="form-group col-md-6">
              <label>Select A Level</label>
              <select class="form-control mb-4" v-model="levelModel">
                    <option selected disabled>-- Select A Level --</option>
                    <option
                      v-for="level in totalLevels"
                      :key="level._id"
                      v-bind:value="level._id"
                    >
                    {{ level.target }}  {{ level.step }}
                    </option>
               </select>
            </div>
            <div class="form-group col-md-6">
              <label>Select A Lesson</label>
              <select class="form-control mb-4" v-model="lessonModel">
                    <option selected disabled>-- Select A Lesson --</option>
                    <option
                      v-for="item in lessons"
                      :key="'lesson' + item"
                      v-bind:value="item"
                    >
                     Lesson  {{ item }}
                    </option>
               </select>
            </div>
            <div class="form-group col-md-6">
              <label>Select A Day</label>
              <select class="form-control mb-4" v-model="dayModel">
                    <option selected disabled>-- Select A Day --</option>
                    <option
                      v-for="item in days"
                      :key="'day' + item"
                      v-bind:value="item"
                    >
                     {{ item }} Day
                    </option>
               </select>
            </div>
            <div class="form-group col-md-6">
              <label>Select A Type</label>
              <select class="form-control mb-4" v-model="typeModel">
                    <option selected disabled>-- Select A Type --</option>
                    <option
                      v-for="item in types"
                      :key="'type' + item"
                      v-bind:value="item.value"
                    >
                     {{ item.name }}
                    </option>
               </select>
            </div>
          </div>

          <!-- Sign in button -->
          <button class="btn btn-info btn-block my-4" @click.prevent="updateProgress()">
            Update Progress
          </button>
        </form>
        <!-- Default form login -->
      </div>
    </div>

    <mdb-modal :show="showResetModal" removeBackdrop centered>
      <mdb-modal-body>
        <h5 class="font-weight-bold">Confirm Smartbook Reset</h5>
        <p class="mb-0">
          Are you sure you want to reset all progress for this Smartbook? This action cannot be undone.
        </p>
        <div class="d-flex justify-content-end mt-4">
          <button class="btn btn-secondary btn-sm mr-2" @click.prevent="showResetModal = false">
            Cancel
          </button>
          <button class="btn btn-danger btn-sm" @click.prevent="resetSmartbook()">
            Reset Smartbook
          </button>
        </div>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mdbModal, mdbModalBody } from "mdbvue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: "EditProgress",
  components: {
    Loading,
    mdbModal,
    mdbModalBody,
  },
  data() {
    return {
      user_id: this.$route.params.student_id,
      fastToken: localStorage.getItem("fastAdminToken") ?? localStorage.getItem("fastTeacherToken"),
      student: [],
      progress: {},
      totalLevels: [],
      lessons: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
      ],
      days: [
        1, 2, 3, 4, 5, 6
      ],
      types: [
        {
          value: 's',
          name: 'Static'
        },
        {
          value: 'a',
          name: 'Audible'
        },
        {
          value: 'f',
          name: 'Flash'
        },
      ],
      levelModel: {},
      lessonModel: null,
      dayModel: null,
      typeModel: null,
      isLoading: false,
      showResetModal: false,
    };
  },
  methods: {
    buildErrorMessage(error) {
      if (!error) {
        return "Unknown error";
      }

      if (error.response) {
        let message = error.response.status + " " + error.response.statusText;
        if (error.response.data) {
          if (typeof error.response.data === "string") {
            message = message + " - " + error.response.data;
          } else if (error.response.data.message) {
            message = message + " - " + error.response.data.message;
          }
        }
        return message;
      }

      if (error.message) {
        return error.message;
      }

      return "Network/Server error please refresh try again";
    },

    openResetModal() {
      if (!this.progress.level_data || !this.student._id) {
        this.$toast.open({
          message: "Error : Student progress is not ready yet",
          type: "error",
        });
        return;
      }
      this.showResetModal = true;
    },

    resetSmartbook() {
      if (!this.progress.level_data || !this.progress.level_data._id) {
        this.$toast.open({
          message: "Error : Current Smartbook level is not available",
          type: "error",
        });
        return;
      }

      this.showResetModal = false;
      this.isLoading = true;
      const data = {
        level: this.progress.level_data._id,
      };

      const config = {
        headers: {
          Authorization: "Bearer " + this.fastToken,
          "Content-Type": "application/json",
        },
      };

      axios
      .post(this.$apiURI + "/progress/reset-smartbook/" + this.student._id, data, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
          this.isLoading = false;
        } else {
          this.$toast.open({
            message: "Smartbook reset successfully",
            type: "success",
          });
          this.initData();
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + this.buildErrorMessage(error),
          type: "error",
        });
        this.isLoading = false;
      });
    },

    updateProgress() {

      if(this.lessonModel == null || this.dayModel == null || this.typeModel == null) {
        this.$toast.open({
                  message: "Error : Please select progress infos",
                  type: "error",
                });
        return;
      }


      this.isLoading = true;
      let data = {
        'level': this.levelModel,
        'lesson': this.lessonModel,
        'day': this.dayModel,
        'type': this.typeModel
      };

      const config = {
        headers: {
          Authorization: "Bearer " + this.fastToken,
          "Content-Type": "application/json",
        },
      };

      axios
      .post(this.$apiURI + "/progress/update/" + this.student._id, data, config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
          this.isLoading = false;
        } else {
          this.initData();
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
        this.isLoading = false;
      });
    },

    initData() {
      this.$toast.open({
        message: "Processing : Loading Plan Please Wait...",
        type: "info",
      });
      this.isLoading = true;
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastToken,
          "Content-Type": "application/json",
        },
      };
      axios
        .get(this.$apiURI + "/account/clone/" + this.user_id, config)
        .then((response) => {

          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
            this.isLoading = false;

          } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.students)
            this.student = response.data.data;
            // this.planTarget = response.data.data.target

            axios
            .get(this.$apiURI + "/progress/current/" + this.student._id, config)
            .then((response) => {
              if (response.data.error) {
                this.$toast.open({
                  message: "Error : " + response.data.message,
                  type: "error",
                });
                this.isLoading = false;

              } else {
                this.progress = response.data.data;
                this.levelModel = this.progress.level_data._id;
                this.lessonModel = parseInt(this.progress.group);
                this.dayModel = this.progress.day;
                this.typeModel = this.progress.type;
                this.isLoading = false;
              }
            })
            .catch((error) => {
              this.$toast.open({
                message: "Error : " + error.response.data.message,
                type: "error",
              });
              this.isLoading = false;
            });
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
          this.isLoading = false;
        });

      axios
        .get(this.$apiURI + "/levels", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            // eslint-disable-next-line no-console
            // console.log(response.data.data.teachers)
            let levels = response.data.data.levels;
            this.totalLevels = levels;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });

    }
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped>
.reset-smartbook-wrapper {
  min-width: 180px;
}

.reset-smartbook-btn {
  border: 1px solid #343a46;
  border-radius: 14px;
  width: 64px;
  height: 64px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #262c39, #1f2530);
  box-shadow: 0 10px 20px rgba(18, 24, 35, 0.16);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.reset-smartbook-btn:hover,
.reset-smartbook-btn:focus {
  transform: translateY(-1px);
  border-color: #4c5668;
  box-shadow: 0 14px 24px rgba(18, 24, 35, 0.22);
}

.reset-smartbook-btn:focus {
  outline: none;
}

.reset-smartbook-btn .material-icons {
  font-size: 34px;
  color: #d9e2f0;
}
</style>
